import _ from "lodash";
import { env as environment, backendUrl, setIsChina, getIsChina } from "config";
import { getBackendUrl, getCustomFetch } from "@toddle-edu/frontend-utils";
import {
  getStreamURL,
  getWebSocketAiBackendUrl,
} from "@toddle-edu/common-utils";

const getServerURL = () => {
  return backendUrl;
};

// Pass `overrideBaseurl: "http://localhost:3001"` to always hit the localhost backend endpoint, and do not add path i.e, /graphql
export const getBackendServerUrl = ({
  region,
  env = environment,
  token,
  path,
  useDefaultRegion,
  overrideBaseurl,
}) => {
  return getBackendUrl({
    overrideBaseurl,
    region,
    token,
    env,
    path,
    useDefaultRegion,
    getStaticBaseurl: getServerURL,
    setIsChina,
    getIsChina,
  });
};

export const getCustomFetchFn = ({ overrideBaseurl } = {}) => {
  const getCustomBackendUrl = overrideBaseurl
    ? params => getBackendServerUrl({ ...params, overrideBaseurl })
    : getBackendServerUrl;

  return getCustomFetch({
    env: environment,
    getCustomBackendUrl,
  });
};

//used for getting thumburl for video else url for image
export const getAttachmentUrlFromFieldValue = ({ fieldValue }) => {
  return (
    _.get(fieldValue, "resolvedMinimalTree.attachment.thumbUrl", "") ||
    _.get(fieldValue, "resolvedMinimalTree.attachment.url", "") ||
    // In some of the fields like LE we take image from its value.
    _.get(fieldValue, "value", "")
  );
};

export const getStreamBackendUrl = ({
  region,
  env = environment,
  token,
  useStreamUrlV2,
  path,
}) => {
  return getStreamURL({
    region,
    token,
    env,
    useStreamUrlV2,
    path,
  });
};

export const getWebSocketUrl = ({ token, env = environment }) => {
  return getWebSocketAiBackendUrl({ token, env });
};

export const getGraphQlPlaygroundUrl = ({ jwt }) => {
  return `${backendUrl}/graphiql?authToken=${jwt}`;
};

export const getEnvironment = () => {
  return environment;
};

/**
 * Checks if the given url is a part of toddleapp.com domain or its subdomains
 * @param {String} url a url to be checked if its a part of toddleapp.com domain
 */
export const isToddleAppSubdomain = url => {
  const parsedUrl = new URL(url);
  const hostname = parsedUrl?.hostname?.toLowerCase();

  const isGlobalToddle =
    hostname === "toddleapp.com" || hostname?.endsWith(".toddleapp.com");
  const isChinaToddle =
    hostname === "toddleapp.cn" || hostname?.endsWith(".toddleapp.cn");

  return isGlobalToddle || isChinaToddle;
};
